module.exports = __webpack_public_path__ + "static/img/cup_green.12b1f4dc.png";